/*
 * Copyright (c) Nexign, JSC, 2020-2025.
 */
/**
 * Tariff And Services Translation
 *
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @author Yakov Gushchin
 * @author Evgeniy Naumov
 * @author Nikolay Sviridov
 * @version 1.39.0
 * @since 1.4.0
 */

import { IPageProductsTranslation } from '../../types/pages/products';

export const initTranslationPageProducts: IPageProductsTranslation = {
    buttonBack: {
        title: '',
    },
    buttonProductManage: {
        differentRegionsText: '',
        servicesLimitText: '',
        titleConnect: '',
        titleDisable: '',
        titleTariff: '',
    },
    campaignTariffsCard: {
        internetLimited: {},
        roaming: {},
        roamingUnlimited: '',
        roamingUnlimitedValues: {
            calls: '',
            sms: '',
            internet: '',
        },
    },
    campaignInfo: '',
    limitConnections: '',
    cards: {
        activationLabel: '',
        connectButtonText: '',
        feeLabel: '',
        freeLabel: '',
        moreInfoLabel: '',
        notAvailableLabel: '',
        moreInfoLabelTariff: '',
        severalOneTimeChargesTooltip: {},
        severalRecurringChargesTooltip: {},
        megaPowersTooltip: '',
        tooltipRange: '',
        cashbackUnit: '',
        cashbackPeriod: '',
    },
    cartChangeToCampaignModal: {
        agreeBtn: '',
        answer: '',
        cancelBtn: '',
        notice: '',
        title: '',
    },
    cartChangeToPublicModal: {
        agreeBtn: '',
        answer: '',
        cancelBtn: '',
        notice: '',
        title: '',
    },
    categoriesTitle: {
        campaignService: '',
        campaignTariff: '',
        selected: '',
        service: '',
        tariff: '',
    },
    filters: {
        payment: {
            all: '',
            noFee: '',
            withFee: '',
        },
        regionSelectedInfo: '',
        selection: {
            all: '',
            selected: '',
        },
        types: {
            available: '',
            connected: '',
            selectedAvailable: '',
            selectedConnected: '',
        },
    },
    error: {
        codes: {},
        defaultMessage: '',
    },
    errorTitle: '',
    header: {
        title: '',
    },
    maxAvailableServicesInfo: '',
    megaPowersServicesInfo: '',
    megaPowersServicesInfoV2: '',
    regionBlock: {
        search: '',
        services: '',
        tariffs: '',
    },
    regionChangeModal: {
        agreeBtn: '',
        answer: '',
        cancelBtn: '',
        notice: '',
        title: '',
    },
    search: {
        inputPlaceholder: '',
        noResultsFilter: '',
        noSearchMatcher: '',
        searchResultsTitle: '',
        showMoore: '',
    },
    selectedElementsTitle: '',
    roamingOptions: {
        recommendedServicesTitle: '',
        noRoamingOptionsForThisCountry: '',
        loading: '',
        controls: {
          title: '',
          placeholder: '',
          noOptionsText: '',
          helpText: '',
          searchInProgress: '',
          searchHint: '',
        },
        card: {
            buttons: {
                connect: '',
                moreInfo: '',
                addOptionalCalls: '',
                removeOptionalCalls: '',
            },
            suitableFor: '',
            payment: {
                in: '',
                for: '',
                oneDay: '',
                twoDays: '',
                fiveDays: '',
            },
        },
      },
};
